/* import __COLOCATED_TEMPLATE__ from './signup-background-form.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, getProperties } from '@ember/object';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import { array, string, object, boolean } from 'yup';
import { validateSchema } from 'sh-www/utils/validators';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import Validator from 'validator';
import {
  handleFormErrorOrModal,
} from 'sh-www/utils/handles-errors';
import clsx from 'clsx';

const SCHEMA = object({
  'description': string().required('You must provide a bio.'),
  'personal_website': string().test(
    'website-requirement',
    'Website must be a valid URL',
    function(value) {
      const protocols = ['http', 'https'];
      return value ? Validator.isURL(value, { protocols }) : true;
    }
  ),
  'equipment': array(),
  'languages': array().required('Please let us know what languages you speak.'),
  'intercountry_travel': boolean()
});

const CLASS_NAME = 'GLM-freelancer-signup-form';
const FORM_INPUTS = [
  'description',
  'personal_website',
  'intercountry_travel',
  'equipment',
  'languages',
];

class SignupBackgroundForm extends Component {
  @service media;
  @service router;

  @tracked description = this.args.user?.description ?? '';
  @tracked personal_website = this.args.profile?.personalWebsite ?? ''
  @tracked equipment = this.args.profile?.equipment.toArray() ?? [];
  @tracked languages = this.args.profile?.languages.toArray() ?? [];
  @tracked intercountry_travel = this.args.profile?.intercountryTravel ?? true;
  @tracked errors = {};

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME
    );
  }

  get baseClassName() {
    return CLASS_NAME;
  }

  get submitDisabled() {
    return this.submitTask.isRunning
      || Object.values(this.errors).some(error => !!error)
      || !this.description
      || this.languages.length < 1;
  }

  @action
  handleBackClicked() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNUP__STEP__PROFILE);
  }

  @action
  validateForm(e) {
    e.preventDefault();
    const [_, validationErrors = {}] = validateSchema(getProperties(this, Object.keys(SCHEMA.fields)), SCHEMA);
    this.errors = validationErrors;

    if (Object.values(this.errors).every(error => !error)) {
      this.submitTask.perform();
    }
  }

  @action
  handleInput(field, value) {
    this[field] = value;
    this.errors = { ...this.errors, [field]: undefined };
  }

  @action
  toggleIntercountryTravel(currentValue) {
    this.intercountry_travel = !currentValue;
  }

  @action
  addChip(prop, value) {
    this[prop] = [ ...this[prop], value ];
    this.errors = { ...this.errors, [prop]: undefined };
  }

  @action
  removeChip(prop, value) {
    this[prop] = this[prop].filter(item => item !== value);
    this.errors = { ...this.errors, [prop]: undefined };
  }

  @dropTask
  *submitTask() {
    try {
      yield this.args.updateUser(getProperties(this, FORM_INPUTS));
    } catch(error) {
      handleFormErrorOrModal(
        this,
        error,
        FORM_INPUTS,
        false,
        'There was an error creating your account. Please refresh and try again.',
        'signupBackgroundFail -- error updating user background.' + JSON.stringify(error)
      );
    }
  }
}

export default SignupBackgroundForm;
